import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

import { Collapse, Row, Col, Well } from "react-bootstrap";
import queryString from "query-string";
import DepartmentSelect from "../common/DepartmentSelect";
import ActiveUsersToggle from "./ActiveUsersToggle";
import UserRolesSelect from "../common/UserRolesSelect";
import UserService from "../../services/userService";
import "./UserFilters.scss";

const UserFilters = ({ loading, open, setLoading, setFilteredUsers }) => {
  const [filters, setFilters] = useState({
    department: [],
    roles: [],
    is_active: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (filters.is_active !== true) {
          delete filters.is_active;
        }

        const query = queryString.stringify(
          {
            ...filters
          },
          {
            arrayFormat: "bracket"
          }
        );

        const data = await UserService.findByFilters(query);

        setFilteredUsers(data);
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (filters) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handleChangeToggle = async (e) => {
    const { checked } = e?.target;
    setFilters({ ...filters, is_active: checked });
  };

  const handleChange = (name) => async (value) => {
    if (Array.isArray(value)) {
      const values = value.map((item) => item.value);
      setFilters({ ...filters, [name]: values });
    } else {
      setFilters({ ...filters, [name]: value });
    }
  };

  const handleResetFilters = () => {
    setFilters({
      department: [],
      roles: [],
      is_active: null
    });
  };

  return (
    <Collapse in={open}>
      <div className="filter-container">
        <Well>
          <Row className="mb-0">
            <div className="center-content">
              <Col md={3}>
                <DepartmentSelect
                  value={filters.department}
                  isMulti
                  onChange={handleChange("department")}
                />
              </Col>
              <Col md={3}>
                <UserRolesSelect
                  value={filters.roles}
                  isMulti
                  onChange={handleChange("roles")}
                />
              </Col>
              <Col md={3}>
                <div className="center-content">
                  <ActiveUsersToggle
                    disabled={loading}
                    is_active={filters.is_active}
                    onChange={handleChangeToggle}
                  />
                </div>
              </Col>
              <Col md={3}>
                <button
                  className="btn btn-warning full-width"
                  type="button"
                  disabled={loading}
                  onClick={() => handleResetFilters()}
                >
                  Reset
                </button>
              </Col>
            </div>
          </Row>
        </Well>
      </div>
    </Collapse>
  );
};

UserFilters.propTypes = {
  loading: PropTypes.bool,
  open: PropTypes.bool,
  setFilteredUsers: PropTypes.func,
  setLoading: PropTypes.func
};

export default UserFilters;
